<mat-card class="mat-elevation-z8">
    <form [formGroup]="route_register_form">
        <!-- user details -->
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label>Route Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                    <input type="text" class="form-control code_box" formControlName='name'>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">Union <i class="material-icons"
                            style="color: red;font-size: 14px;">star</i></label>
                    <select class="form-control dropdown_box" formControlName='union_id'>
                        <option *ngFor="let union of unions" [value]="union['id']">{{union['name']}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">Session <i class="material-icons"
                            style="color: red;font-size: 14px;">star</i></label>
                    <select class="form-control dropdown_box" formControlName='session_id'>
                        <option *ngFor="let session of sessions" [value]="session['id']">{{session['name']}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>Order Expiry Time <i class="material-icons"
                            style="color: red;font-size: 14px;">star</i></label>
                    <input type="time" class="form-control code_box" formControlName='order_expiry_time'>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>Departure Time <i class="material-icons"
                            style="color: red;font-size: 14px;">star</i></label>
                    <input type="time" class="form-control code_box" formControlName='departure_time'>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">Select Vehicle<i class="material-icons"
                            style="color: red;font-size: 14px;">star</i></label>
                    <select class="form-control dropdown_box" formControlName='vehicle_id'>
                        <option *ngFor="let vehicle of vehicles" [value]="vehicle['id']">
                            {{vehicle['name']}} - {{vehicle['vehicle_type_name']}} - {{vehicle['licence_number']}} -
                            {{vehicle['driver_name']}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <button style="margin-left: 40%;" mat-raised-button color="primary" (click)="onChange()"
            [disabled]="!route_register_form.valid">{{action}}</button>
    </form>
</mat-card>
